<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="row px-3">
    <div class="col-6">
      <p class="titleFont">
        {{ "label.claim.claimDetails.eyewitnessDetails" | translate }}
      </p>
    </div>
    <div class="col-6 text-right">
      <div class="circle circle-plus">
        <img src="{{ addIcon }}" alt="Plus Icon" class="plus-icon" />
      </div>
    </div>
  </div>
  <ng-container *ngIf="getEyewitnessDetails.length > 0">
    <ng-container *ngIf="selectedCircleIndex >= 0">
      <div class="card mt-2 px-3 pt-4 pb-2">
        <div class="row">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 circle-container">
            <div
              *ngFor="let circle of getEyewitnessDetails; let i = index"
              class="circle"
              [ngClass]="{
                'blue-border': selectedCircleIndex === i,
                'purple-color': selectedCircleIndex !== i
              }"
              (click)="selectCircle(i)"
            >
              {{ i + 1 }}
            </div>
          </div>
        </div>
        <div class="row labelContent mt-3">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.eyewitnessName" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <custom-input-text
              placeholder="-"
              (valueChange)="onDataInput($event, 'name', '')"
              [model]="eyeWitnessDetail.name"
              [disabled]="true"
            ></custom-input-text>
          </div>
        </div>
        <div class="row labelContent">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.contactNo" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 d-flex">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 px-0">
              <custom-select
                placeholdername="-"
                [autoOptions]="dialCodesArr"
                (valueChange)="onDataInput($event, 'countryCode', '')"
                [value]="eyeWitnessDetail.countryCode"
                [disabled]="true"
              ></custom-select>
            </div>
            <div
              class="col-xl-10 col-lg-10 col-md-9 col-sm-12 px-0 contactInput"
            >
              <custom-input-text
                placeholder="-"
                placeholder="-"
                digitOnly
                placeholder="-"
                (valueChange)="onDataInput($event, 'contactNumber', 17)"
                [model]="eyeWitnessDetail.contactNumber"
                [disabled]="true"
              ></custom-input-text>
            </div>
          </div>
        </div>

        <div class="row labelContent">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.address" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <custom-input-text
              placeholder="-"
              (valueChange)="onDataInput($event, 'address', '')"
              [model]="eyeWitnessDetail.address"
              [disabled]="true"
            ></custom-input-text>
          </div>
        </div>
        <div class="row labelContent">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.relationWithLA" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <custom-input-text
              placeholder="-"
              (valueChange)="onDataInput($event, 'relationship', '')"
              [model]="eyeWitnessDetail.relationship"
              [disabled]="true"
            ></custom-input-text>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>
